import TemplateView from '../../../../TemplateView'
import WorkScheduleRow from './WorkScheduleRow'
import {getEffectiveDate} from '../utils'
import {ValidationErrors} from '../../constants'
import {ShowWarning} from '../userRates/constants'

export default class WorkScheduleList extends TemplateView {
    constructor({
        editMode,
        readOnly,
        scrollTo = () => {},
        onScheduleChanged = () => {},
        deleteWorkSchedule = () => {},
        refreshScrollCb = () => {},
        subscribeSelectorOnScroll = () => {},
    }) {
        super()

        this.params = {
            editMode,
            readOnly,
            scrollTo,
        }

        this.callbacks = {
            onScheduleChanged,
            deleteWorkSchedule,
            refreshScrollCb,
            subscribeSelectorOnScroll,
        }

        this.state = {
            useDefaultSchedule: false,
            defaultWorkSchedule: [],
            workSchedule: [],
            readOnly: this.params.readOnly,

            currentDate: null,
            weekStartDay: null,
            invertedDays: {},
            decimalSeparator: null,
        }

        this.schedulesMap = {}

        this.onStateChanged(() => this._updateRows())
    }

    templateHtml() {
        return '<div class="workScheduleList"/>'
    }

    _updateRows() {
        this.getEl().empty()
        this.schedulesMap = {}

        const effectiveDate = getEffectiveDate(this.state.workSchedule.map(s => s.effectiveDate), this.state.currentDate)

        this.state.workSchedule.forEach((schedule, index) => {
            const node = new WorkScheduleRow({
                readOnly: this.state.readOnly,
                scrollTo: this.params.scrollTo,
                onChangeCb: schedule => this._handleScheduleRowChanged(index, schedule),
                onDeleteCb: ({removePermanently}) => this.callbacks.deleteWorkSchedule({
                    scheduleToRemove: {...schedule, oldEffectiveDate: schedule.effectiveDate},
                    removePermanently,
                    index
                }),
                rollbackEffectiveDateChanges: () => {
                    node.setState({
                        effectiveDate: schedule.effectiveDate,
                        error: null,
                    })
                    Object.values(this.schedulesMap).forEach(schedule => schedule.setState({error: null}))
                },
                subscribeSelectorOnScroll: this.callbacks.subscribeSelectorOnScroll,
            }).init(this.getEl())

            node.setState({
                oldEffectiveDate: schedule.effectiveDate,
                effectiveDate: schedule.effectiveDate,
                durations: schedule.durations,
                weekStartDay: this.state.weekStartDay,
                invertedDays: this.state.invertedDays,
                useDefaultSchedule: schedule.sameAsDefault,
                defaultWorkSchedule: this.state.defaultWorkSchedule,
                currentDate: this.state.currentDate,
                effective: effectiveDate !== null && effectiveDate === schedule.effectiveDate,
            })

            this.schedulesMap[index] = node
        })

        this.callbacks.refreshScrollCb()
    }

    _handleScheduleRowChanged(index, {effectiveDate, oldEffectiveDate, durations, sameAsDefault}) {
        const newSchedule = {effectiveDate, oldEffectiveDate, durations, sameAsDefault}
        const schedules = this.state.workSchedule.map(schedule => ({...schedule, oldEffectiveDate: schedule.effectiveDate}))
        schedules.splice(index, 1, newSchedule)

        const sameEffectiveDateSchedule = schedules.find(schedule => schedule.oldEffectiveDate === effectiveDate)

        if (effectiveDate !== oldEffectiveDate && sameEffectiveDateSchedule) {
            schedules.forEach((schedule, index) => {
                this.schedulesMap[index].setState({
                    error: {
                        [ValidationErrors.DUPLICATED_EFFECTIVE_DATE]: sameEffectiveDateSchedule.effectiveDate === schedule.oldEffectiveDate
                    }
                })
            })
            this.schedulesMap[index].setState({
                effectiveDate,
                error: {
                    [ValidationErrors.DUPLICATED_EFFECTIVE_DATE]: true,
                    showWarning: this.params.editMode ? ShowWarning.EFFECTIVE_DATE_WARNING : false,
                }
            })
        } else {
            this.callbacks.onScheduleChanged(schedules)
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/workSchedule/WorkScheduleList.js